import { Button, Modal } from "antd";
import { useState } from "react";
import "./CreateFolderModal.scss";
import DesignApi from "../../api/DesignApi";
import { DesignDto } from "../../generated/dashboard-client";
import DSAApi from "../../api/DSAApi";

export interface ConfirmDeleteModalProps {
  isVisible: boolean;
  ids: string[];
  designs: DesignDto[],
  design: DesignDto,
  onClose: (removed: boolean) => void;
}

export function ConfirmDeleteModal({
  isVisible,
  ids,
  designs,
  design,
  onClose,
}: ConfirmDeleteModalProps) {
  const [removing, setRemoving] = useState(false);

  function remove() {
    setRemoving(true);
    DesignApi.removeAll(ids)
      .then(() => {
        DSAApi.getPlaylists().then(resp => {
          const playlists = resp.data;
          ids.forEach(id => {
            playlists.forEach(p => {
              if (p.entries?.find(e => e.designId === id)) {
                let filteredEntries = p.entries.filter(e => e.designId !== id);
                filteredEntries.forEach(fe => {
                  fe.sequence = filteredEntries.indexOf(fe);
                });
                p.entries = filteredEntries;
                DSAApi.updatePlaylist(p.id!, p).then(() => {
                  console.log(`Removed design ${id} from playlist ${p.id!}`);
                });
              }
            })
          })
        })

        setRemoving(false);
        onClose(true);
      })
      .catch(() => {
        setRemoving(false);
      });
  }

  return (
    <Modal
      className={"clean one"}
      visible={isVisible}
      onCancel={() => onClose(false)}
    >
      <header>
        <h2>Are you sure?</h2>
      </header>

      <p>
        {ids.length > 1 ? "These designs" : "The design"} will be permanently
        deleted from your account.
      </p>

      <footer>
        <Button size={"large"} onClick={() => onClose(false)}>
          Cancel
        </Button>
        <Button
          size={"large"}
          className={"primary"}
          onClick={remove}
          loading={removing}
        >
          Delete
        </Button>
      </footer>
    </Modal>
  );
}
